module.exports = __webpack_public_path__ + "img/lions-logo-icon.05dd9f19.png";